const validate = (file: File): string | null => {

    if (!(file instanceof File)) {
        return 'A file is required';
    }

    return null;
};

export default validate;